import { AfterViewChecked, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SurveyQuestionComponent } from '../survey-question/survey-question.component';
import { EmailAnswers, Survey, SurveyService } from '../services/survey.service';
import {EmailConfirmationService} from "../services/email-confirmation.service";

@Component({
    selector: 'ell-survey-email',
    standalone: true,
    imports: [RouterLink, SurveyQuestionComponent, FormsModule],
    templateUrl: './survey-email.component.html',
    styleUrl: './survey-email.component.scss'
})
export class SurveyEmailComponent implements AfterViewChecked {
    error = '';

    answers: EmailAnswers = {
        contactEmail: ''
    };

    showConfirmationBox = false;
    confirmedEmail: string | null = null
    confirmationCode: string = '';

    @Input()
    survey?: Survey;

    @Output()
    complete = new EventEmitter<EmailAnswers>();

    @ViewChildren(SurveyQuestionComponent)
    questions!: QueryList<SurveyQuestionComponent<any>>;

    constructor(private surveyService: SurveyService, private emailConfirmationService: EmailConfirmationService) {
    }

    async next() {
        this.error = '';
        if (!this.answers.contactEmail || !this.validEmail(this.answers.contactEmail)) {
            this.error = $localize`Please provide an email address.`;
        } else if (!this.confirmedEmail || this.confirmedEmail !== this.answers.contactEmail) {
            await this.checkEmailConfirmation();
        }
        if (this.confirmedEmail === this.answers.contactEmail && !this.error) {
            // validation passed continue!
            this.surveyService.email = this.answers.contactEmail;
            this.complete.emit(this.answers);
            return;
        }
    }

    ngAfterViewChecked(): void {
        if (this.survey) {
            this.surveyService.registerQuestions(this.survey, this.questions);
        }
    }

    private validEmail(email: string): boolean {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    }

    public async checkEmailConfirmation() {
        if (!this.validEmail(this.answers.contactEmail)) {
            return;
        }
        if (await this.emailConfirmationService.isConfirmed(this.answers.contactEmail)) {
            this.confirmedEmail = this.answers.contactEmail;
        } else {
            this.showConfirmationBox = true;
        }
    }

    public async confirmEmail() {
        if (await this.emailConfirmationService.confirmEmail(this.answers.contactEmail, this.confirmationCode)) {
            this.confirmedEmail = this.answers.contactEmail;
            this.showConfirmationBox = false;
            this.error = '';
        } else {
            this.error = $localize`The confirmation code you entered is incorrect. Please try again.`;
        }
    }
}
